import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";
import BCLogo from "../../images/BCLogo.png";
import MassHumanitiesLogo from "../../images/massHumanitiesLogo.jpg";
import CCLTLogo from "../../images/CCLTLogo.png";
import NTHPLogo from "../../images/NTHPLogo.jpg";

const About = () => {
  const intl = useIntl();

  return (
    <Wrapper>
      <ContentWrapper locale={intl.locale}>
        <Header>
          <FormattedMessage id="about.header" defaultMessage={"About"} />
        </Header>
        <span>
          <SubHeader>
            <FormattedMessage
              id="about.what"
              defaultMessage={"What is the Immigrant History Trail?"}
            />
          </SubHeader>
          <Content>
            <FormattedMessage
              id="about.whatContent"
              defaultMessage={
                "The Immigrant History Trail is a multimedia public art project that activates Boston Chinatown's community archives to share stories about the neighborhood's working class immigrant histories."
              }
              tagName={"p"}
            />
            <FormattedMessage
              id="about.whatContent2"
              defaultMessage={
                "Plaques will hang on the walls of buildings across Boston Chinatown, inviting visitors to navigate the neighborhood with curiosity. QR codes link to this website, which highlights relevant text, images, and audio fragments, and points to where visitors can learn more."
              }
              tagName={"p"}
            />
            <FormattedMessage
              id="about.whatContent3"
              defaultMessage={
                "This project is a community stewarded resource that will be updated regularly with new contributions of sites and stories for the Immigrant History Trail."
              }
              tagName={"p"}
            />
          </Content>
        </span>
        <ImageWrapper>
          <img
            src="https://res.cloudinary.com/pang-dev/image/upload/v1744243088/CCLT/IMG_2288_1_kiisgw.png"
            alt="Tang Jianhua posing beside a photograph of herself and her gourds"
          />
          {/* press cmd + / or ctrl + / to reactivate (un-comment) the caption line, the bottom one is for chinese text */}
          {/* <span>caption goes here</span> */}
          {/* <span style={{ fontFamily: "Noto Serif TC, sans serif" }}>caption goes here</span> */}
        </ImageWrapper>
        <span>
          <SubHeader>
            <FormattedMessage id="about.why" defaultMessage={"Why?"} />
          </SubHeader>
          <Content>
            <FormattedMessage
              id="about.whyContent"
              defaultMessage={
                "Boston Chinatown is at a crossroads after absorbing decades of urban renewal, zoning injustice, and institutional expansion, followed by luxury highrise development. The future of the immigrant, working -class residential and small business core that has characterized the neighborhood for 180 years is at risk. Now, more than ever, there is a need to make working -class immigrant histories of Chinatown known, accessible, and celebrated."
              }
              tagName={"p"}
            />
          </Content>
        </span>
        <span>
          <SubHeader>
            <FormattedMessage id="about.how" defaultMessage={"How?"} />
          </SubHeader>
          <Content>
            <FormattedMessage
              id="about.howContent"
              defaultMessage={
                "Boston has a long history of neighborhood activism, and the Immigrant History Trail involves a similar grassroots and iterative mentality. We will engage local community members to collaborate with us as advisors and participants by contributing stories and memories, selecting sites for the Trail, creating archival resources, and more. We are committed to creating a participatory, non-linear Trail that emerges from community involvement. Residents, workers, small business owners, and organizers can all contribute stories, research, and audiovisual media, and engage their fellow community members."
              }
              tagName={"p"}
            />
          </Content>
        </span>
        <ImageWrapper>
          <img
            src="https://res.cloudinary.com/pang-dev/image/upload/v1744243088/CCLT/IMG_2339_1_ahtle5.png"
            alt="Boston Chinatown Community Land Trust team members posing"
          />
          {/* <span>caption goes here</span> */}
          {/* <span style={{ fontFamily: "Noto Serif TC, sans serif" }}>caption goes here</span> */}
        </ImageWrapper>
        <span>
          <SubHeader>
            <FormattedMessage id="about.who" defaultMessage={"Who?"} />
          </SubHeader>
          <Content>
            <FormattedMessage
              id="about.whoContent"
              defaultMessage={
                "We would like to thank Mass Humanities and the City of Boston Transformative Public Art Grant for support. We would also like to thank our partners including Boston Research Center and all current and past volunteer Immigrant History Trail Committee members."
              }
              tagName={"p"}
            />
            <FormattedMessage
              id="about.whoContent2"
              defaultMessage={
                "While the Chinatown Community Land Trust is launching the Immigrant History Trail, the project idea originated during a conversation among many community partners held at the Chinese Historical Society of New England (CHSNE) in 2019, as community members discussed historic preservation for the 2020 Chinatown Master Plan. We would like to honor Tunney Lee (1931-2020), who was present in this conversation and enthusiastic about creating an iterative QR-code trail to show Chinatown's archival images to its visitors."
              }
              tagName={"p"}
            />
            <FormattedMessage
              id="about.whoContent3"
              defaultMessage={
                "The core Immigrant History Trail team includes Daphne Xu, Lydia Lowe, Vivian WuWong, Lily Xie, Elisha Zhao, Franny Xi Wu. The website team includes Eric Han, Wei Qi, Diane Zhou. Fabrication and installation of physical signage is by Jaywalk Studio. The Immigrant History Trail has a volunteer Advisory Committee which works to continue building the Trail."
              }
              tagName={"p"}
            />
          </Content>
        </span>
        <Border />
        <span>
          <SubHeader style={{ fontWeight: "bold" }}>Acknowledgements</SubHeader>
          <Content>
            The Immigrant History Trail is funded in part by the Mayor's Office
            of Arts and Culture of the City of Boston, Mass Humanities with
            funding from the Barr Foundation, and by a grant from the National
            Trust Preservation Fund of the National Trust for Historic
            Preservation.
          </Content>
          <Content>
            Thank you to the members of the Immigrant History Trail Committee
            which advised the project, conducted research, wrote and edited
            text, found photographs, and performed many other tasks to begin
            building the trail: Christina Chan, Krista Chan, Collyn Chan, Chutze
            Chou, Stephanie Fan, Maria Fong, Olivia Fong, Dory Klein, Henry Ko,
            Michael Liu, Nancy Lo, Lydia Lowe, Feronia Mei, Joseph Nevins,
            Franny Xi Wu, Jean Wu, Vivian WuWong, Lily Xie, Daphne Xu, Hongyan
            Yang, Cynthia Yee, Kenneth Yee, Anita Yip, Elisha Zhao,
          </Content>
          <Content>
            Thank you to Alice Kane and the Chinese Historical Society of New
            England; Kenneth Eng, Nancy Lo, and the Chinese Consolidated
            Benevolent Association; Dory Klein and the Boston Public Library;
            Giordana Mecagni and the Northeastern University Archives; Chloe
            Bordewich and Lydia Harrington of the Little Syria Project; and the
            Pao Arts Center for their partnership, advice, support, and sharing
            of resources as we developed the Immigrant History Trail.
          </Content>
          <Content>
            Thank you to the interviewees who have contributed time to build and
            share their oral histories: Joanne Bethoney Carter, Eva Peter
            Chojnowski, Betty Lutfy Dimeco, Russell Eng, Ann Moy, Brian Moy,
            Marie Moy, George Salah, Rosanne Solomon, Jianhua Tang, Jeffrey
            Wong, Cynthia Yee
          </Content>
          <Content>
            Thank you to Professor Hongyan Yang and her Boston College course
            Making American Landscapes: Building and Living in Asian America for
            extensive support in researching the following sites. 25-29 Beach
            Street: Ines Angara Hamilton A Areddy Jennifer L Bartlett Cassandra
            J Kavanagh Chinese Merchants Association: Maxwell K. Guan Ashton Kao
            Dan T. Nguyen Ethan Sun Globe Theater: Ric J. DeLyons Kaetlynn C.
            King-Velez Mary E. Zagrocki Hong Far Low Restaurant: Shirley J.
            Canales Kiran Hebert Claire Kildahl Aina Yamagishi John Assaf Home:
            Connor J. Capshaw Emma J. Cunningham Nicholas R. Rhodes Katelynn
            Wasta Kwong Kow Chinese School: Alisa G. Cufone Grace L. Concannon
            Hi'ilei G. Leong Kendall Torres Maryknoll Sisters Center: Isabella
            M. Ayalew Josiah S. Odhiambo Mica Quelle Saifya N. Stewart
            Shakespeare Inn: Jeremiah Alhassan Tommy Bi Ashley S. Choi Jenna
            Jiang Sofia Rugova Tunney Lee Home: Chelsea Lee Madeline G. Cunniff
            Mae S. Carroll Sophia C. Comparato
          </Content>
          <Content>
            Thank you to Giselle Chu, Emily Hiltunen, and Rachel Liu, project
            assistants for the class. Thank you to their following advisors:
            Eddie Bonilla, Lynn Johnson, Michael Liu, Lydia Lowe, Steve Runge,
            Erin Scheopner, Vivian WuWong.
          </Content>
        </span>
        <Sponsers>
          <img src={MassHumanitiesLogo} alt="mass humanities logo" />
          <img src={BCLogo} alt="boston logo" />
          <img src={CCLTLogo} alt="chinatown community land trust logo" />
          <img src={NTHPLogo} alt="national trust preservation fund logo" />
        </Sponsers>
      </ContentWrapper>
    </Wrapper>
  );
};

const ImageWrapper = styled.div`
  font-family: "Quattrocento";
  color: #423f67;

  img {
    width: 100%;
    height: auto;
  }
  span {
    margin-top: 8px;
  }
`;

const Sponsers = styled.div`
  font-family: "Rowdies";
  font-weight: 300;
  font-size: 24px;
  line-height: 30px;
  color: #423f67;

  display: flex;
  gap: 1rem;
  img {
    height: 100px;
  }
`;

const Border = styled.div`
  margin: 40px 0px;
  height: 1px;
  width: 100%;

  background: rgba(66, 63, 103, 0.25);
`;

const Content = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  color: #1e1e1e;
`;

const SubHeader = styled.div`
  margin-top: 8px;

  font-style: normal;
  line-height: 30px;

  color: #423f67;
`;

const Header = styled.div`
  font-style: normal;
  font-size: 32px;
  line-height: 120%;

  gap: 6px;
  display: flex;
  flex-direction: column;

  text-transform: uppercase;

  color: #423f67;

  div:not(:first-child) {
    font-weight: 800;
  }
`;

const Wrapper = styled.div`
  background-color: #fbf6e9;
  box-sizing: border-box;
  padding: 33px;
  display: flex;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  margin-top: 33px;
  padding: 32px;
  width: 900px;
  display: flex;
  gap: 48px;

  flex-direction: column;
  box-sizing: border-box;

  @media (max-width: 600px) {
    margin-top: 0px;
    padding: 0px;
  }

  span {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  ${Header} {
    font-family: ${(props) =>
      props.locale === "zh" ? "Noto Serif TC" : "Rowdies"};
    font-weight: ${(props) => (props.locale === "zh" ? 900 : 600)};
  }

  ${SubHeader} {
    font-family: ${(props) =>
      props.locale === "zh" ? "Noto Serif TC" : "Rowdies"};
    font-weight: ${(props) => (props.locale === "zh" ? 900 : 600)};
    font-size: ${(props) => (props.locale === "zh" ? "24px" : "18px")};
  }

  ${Content} {
    font-family: ${(props) =>
      props.locale === "zh" ? "Noto Serif TC" : "Quattrocento"};
  }
`;

export default About;
